import { Request } from '../../../httpClient/serverApi/requests/Request';
import { GetFlowOutputStepRunsResult } from './GetFlowOutputStepRunsRequest';

export type GetMostRecentFlowOutputStepRunRequestParams = {
  readonly flowId: string;
  readonly completedRunsOnly: boolean;
};

export class GetMostRecentFlowOutputStepRunRequest extends Request<GetMostRecentFlowOutputStepRunRequestParams, GetFlowOutputStepRunsResult> {
  constructor(params: GetMostRecentFlowOutputStepRunRequestParams) {
    super('getMostRecentFlowOutputStepRun', params);
  }
}
